// AUTO-GENERATED by scripts/extract-marketing-lite.js — do not edit by hand.
// Regenerate after changing src/data/marketingPages.js:
//   node scripts/extract-marketing-lite.js
const MARKETING_PAGE_META = [
    {
        "path": "/use-cases/message-yourself",
        "title": "Message Yourself, but Organized | Luckynote",
        "kind": "use_case",
        "heroEyebrow": "Use case",
        "lastmod": "2026-04-01"
    },
    {
        "path": "/use-cases/save-from-web",
        "title": "Save Links Online in One Place | Luckynote",
        "kind": "use_case",
        "heroEyebrow": "Use case",
        "lastmod": "2026-09-08"
    },
    {
        "path": "/ai-notes",
        "title": "AI Notes App for Search, Summaries, and Recall | Luckynote",
        "kind": "use_case",
        "heroEyebrow": "AI notes",
        "lastmod": "2026-08-20"
    },
    {
        "path": "/chatgpt-notes",
        "title": "ChatGPT for Notes? Use AI Search on What You Save | Luckynote",
        "kind": "use_case",
        "heroEyebrow": "AI notes",
        "lastmod": "2026-08-20"
    },
    {
        "path": "/compare/google-keep-alternative",
        "title": "Google Keep Alternative | Luckynote",
        "kind": "comparison",
        "heroEyebrow": "Comparison",
        "lastmod": "2026-07-07"
    },
    {
        "path": "/compare/google-keep-alternatives",
        "title": "Google Keep Alternatives | Luckynote",
        "kind": "comparison",
        "heroEyebrow": "Comparison",
        "lastmod": "2026-08-30"
    },
    {
        "path": "/compare/apple-notes-alternative",
        "title": "Apple Notes Alternative | Luckynote",
        "kind": "comparison",
        "heroEyebrow": "Comparison",
        "lastmod": "2026-07-07"
    },
    {
        "path": "/compare/pocket-alternatives",
        "title": "Best Pocket Alternatives 2026: 7 Read-It-Later Apps Compared | Luckynote",
        "kind": "comparison",
        "heroEyebrow": "Comparison",
        "lastmod": "2026-08-20"
    },
    {
        "path": "/for/mental-health",
        "title": "A Private Place to Get Thoughts Out | Luckynote",
        "kind": "persona",
        "icon": "FiMessageCircle",
        "iconColor": "#0f766e",
        "iconBackground": "rgba(15, 118, 110, 0.12)",
        "heroEyebrow": "For getting thoughts out",
        "lastmod": "2026-07-13"
    },
    {
        "path": "/for/people-who-text-themselves",
        "title": "The App for People Who Text Themselves | Luckynote",
        "kind": "persona",
        "icon": "FiMessageSquare",
        "iconColor": "#2b88d9",
        "iconBackground": "rgba(43, 136, 217, 0.12)",
        "heroEyebrow": "For people who text themselves",
        "lastmod": "2026-07-12"
    },
    {
        "path": "/for/adhd",
        "title": "A Notes App for ADHD Brains | Luckynote",
        "kind": "persona",
        "icon": "FiInbox",
        "iconColor": "#7c3aed",
        "iconBackground": "rgba(124, 58, 237, 0.12)",
        "heroEyebrow": "For ADHD brains",
        "lastmod": "2026-07-12"
    },
    {
        "path": "/for/indie-hackers",
        "title": "Luckynote for Indie Hackers | Capture the Context",
        "kind": "persona",
        "icon": "FiCode",
        "iconColor": "#0891b2",
        "iconBackground": "rgba(8, 145, 178, 0.12)",
        "heroEyebrow": "For indie hackers",
        "lastmod": "2026-07-12"
    },
    {
        "path": "/for/founders",
        "title": "Luckynote for Founders | Keep the Context Behind the Decisions",
        "kind": "persona",
        "icon": "FiMapPin",
        "iconColor": "#7c3aed",
        "iconBackground": "rgba(124, 58, 237, 0.12)",
        "heroEyebrow": "For founders",
        "lastmod": "2026-09-29"
    },
    {
        "path": "/for/solopreneurs",
        "title": "Luckynote for Solopreneurs | Keep Your Business Context Findable",
        "kind": "persona",
        "icon": "FiBriefcase",
        "iconColor": "#c2410c",
        "iconBackground": "rgba(194, 65, 12, 0.12)",
        "heroEyebrow": "For solopreneurs",
        "lastmod": "2026-09-29"
    },
    {
        "path": "/for/creators",
        "title": "Luckynote for Creators | Save the Idea Before the Scroll Moves On",
        "kind": "persona",
        "icon": "FiCamera",
        "iconColor": "#db2777",
        "iconBackground": "rgba(219, 39, 119, 0.12)",
        "heroEyebrow": "For creators",
        "lastmod": "2026-09-29"
    },
    {
        "path": "/for/tab-hoarders",
        "title": "Luckynote for Tab Hoarders | Save It, Close It, Find It Later",
        "kind": "persona",
        "icon": "FiMonitor",
        "iconColor": "#ea580c",
        "iconBackground": "rgba(234, 88, 12, 0.12)",
        "heroEyebrow": "For tab hoarders",
        "lastmod": "2026-07-12"
    },
    {
        "path": "/for/students",
        "title": "Luckynote for Students | Search Your Notes, Screenshots, and Voice Memos",
        "kind": "persona",
        "icon": "FiBookOpen",
        "iconColor": "#2563eb",
        "iconBackground": "rgba(37, 99, 235, 0.12)",
        "heroEyebrow": "For students",
        "lastmod": "2026-07-12"
    },
    {
        "path": "/for/writers",
        "title": "Luckynote for Writers | Capture Ideas, Research, and Source Notes",
        "kind": "persona",
        "icon": "FiEdit3",
        "iconColor": "#b45309",
        "iconBackground": "rgba(180, 83, 9, 0.12)",
        "heroEyebrow": "For writers",
        "lastmod": "2026-07-13"
    },
    {
        "path": "/for/researchers",
        "title": "Luckynote for Researchers | Save Sources and Find Them Again",
        "kind": "persona",
        "icon": "FiSearch",
        "iconColor": "#0f766e",
        "iconBackground": "rgba(15, 118, 110, 0.12)",
        "heroEyebrow": "For researchers",
        "lastmod": "2026-07-13"
    },
    {
        "path": "/for/parents",
        "title": "Luckynote for Parents | Organize School Papers, Screenshots, and Family Admin",
        "kind": "persona",
        "icon": "FiHeart",
        "iconColor": "#db2777",
        "iconBackground": "rgba(219, 39, 119, 0.12)",
        "heroEyebrow": "For parents",
        "lastmod": "2026-07-13"
    },
    {
        "path": "/for/shopping",
        "title": "Luckynote for Shopping | Save Products, Screenshots, and Receipts in One Place",
        "kind": "persona",
        "icon": "FiShoppingBag",
        "iconColor": "#be123c",
        "iconBackground": "rgba(190, 18, 60, 0.12)",
        "heroEyebrow": "For shopping",
        "lastmod": "2026-07-12"
    },
    {
        "path": "/download/mobile",
        "title": "Download Luckynote for mobile",
        "kind": "download",
        "heroEyebrow": "Mobile apps",
        "lastmod": "2026-09-24"
    },
    {
        "path": "/download-app",
        "title": "Download Luckynote",
        "kind": "download",
        "heroEyebrow": "Download",
        "lastmod": "2026-07-05"
    },
    {
        "path": "/download/browser-extension",
        "title": "Luckynote Web Clipper | Save from Anywhere",
        "kind": "download",
        "heroEyebrow": "Download",
        "lastmod": "2026-09-24"
    },
    {
        "path": "/use-cases/screenshots",
        "title": "Organize Screenshots with AI Search | Luckynote",
        "kind": "use_case",
        "heroEyebrow": "Use case",
        "lastmod": "2026-07-06"
    },
    {
        "path": "/use-cases/x-bookmarks",
        "title": "Search and Organize Your X (Twitter) Bookmarks | Luckynote",
        "kind": "use_case",
        "heroEyebrow": "Use case",
        "lastmod": "2026-09-21"
    },
    {
        "path": "/use-cases/voice-notes",
        "title": "Voice Notes That Become Searchable Text | Luckynote",
        "kind": "use_case",
        "icon": "FiMic",
        "iconColor": "#f97316",
        "iconBackground": "rgba(249, 115, 22, 0.12)",
        "heroEyebrow": "Use case",
        "lastmod": "2026-10-07"
    },
    {
        "path": "/use-cases/second-brain",
        "title": "Build a Second Brain Without a System to Maintain | Luckynote",
        "kind": "use_case",
        "icon": "FiLayers",
        "iconColor": "#2b88d9",
        "iconBackground": "rgba(43, 136, 217, 0.12)",
        "heroEyebrow": "Use case",
        "lastmod": "2026-07-12"
    },
    {
        "path": "/use-cases/read-it-later",
        "title": "A Read-It-Later App for Life After Pocket | Luckynote",
        "kind": "use_case",
        "icon": "FiBookOpen",
        "iconColor": "#16a34a",
        "iconBackground": "rgba(22, 163, 74, 0.12)",
        "heroEyebrow": "Use case",
        "lastmod": "2026-07-12"
    },
    {
        "path": "/use-cases/screenshot-organization",
        "title": "Organize Screenshots and Search Them by Text | Luckynote",
        "kind": "use_case",
        "icon": "FiImage",
        "iconColor": "#7c3aed",
        "iconBackground": "rgba(124, 58, 237, 0.12)",
        "heroEyebrow": "Use case",
        "lastmod": "2026-07-12"
    },
    {
        "path": "/use-cases/life-admin",
        "title": "Luckynote for Life Admin | Keep Receipts, Forms, and Confirmations Searchable",
        "kind": "use_case",
        "icon": "FiClipboard",
        "iconColor": "#b45309",
        "iconBackground": "rgba(180, 83, 9, 0.12)",
        "heroEyebrow": "Use case",
        "lastmod": "2026-07-13"
    },
    {
        "path": "/use-cases/personal-inbox",
        "title": "One Personal Inbox for Everything You Need Later | Luckynote",
        "kind": "use_case",
        "icon": "FiInbox",
        "iconColor": "#2563eb",
        "iconBackground": "rgba(37, 99, 235, 0.12)",
        "heroEyebrow": "Use case",
        "lastmod": "2026-07-13"
    },
    {
        "path": "/use-cases/file-transfer",
        "title": "Transfer Files Between Phone and Computer | Luckynote",
        "kind": "use_case",
        "icon": "FiSend",
        "iconColor": "#0f766e",
        "iconBackground": "rgba(15, 118, 110, 0.12)",
        "heroEyebrow": "Use case",
        "lastmod": "2026-07-13"
    },
    {
        "path": "/use-cases/note-to-self",
        "title": "Note to Self App for Fast Thoughts | Luckynote",
        "kind": "use_case",
        "icon": "FiMessageCircle",
        "iconColor": "#9333ea",
        "iconBackground": "rgba(147, 51, 234, 0.12)",
        "heroEyebrow": "Use case",
        "lastmod": "2026-07-13"
    },
    {
        "path": "/use-cases/copy-paste-between-devices",
        "title": "Copy and Paste Between Devices | Luckynote",
        "kind": "use_case",
        "icon": "FiCopy",
        "iconColor": "#0369a1",
        "iconBackground": "rgba(3, 105, 161, 0.12)",
        "heroEyebrow": "Use case",
        "lastmod": "2026-07-13"
    },
    {
        "path": "/use-cases/recipes",
        "title": "Luckynote for Saved Recipes | Find Recipe Screenshots, Reels, and Links Again",
        "kind": "use_case",
        "icon": "FiBookOpen",
        "iconColor": "#16a34a",
        "iconBackground": "rgba(22, 163, 74, 0.12)",
        "heroEyebrow": "Use case",
        "lastmod": "2026-07-13"
    },
    {
        "path": "/use-cases/travel",
        "title": "Luckynote for Travel Planning | Save Trip Ideas, Screenshots, and Confirmations",
        "kind": "use_case",
        "icon": "FiMapPin",
        "iconColor": "#0891b2",
        "iconBackground": "rgba(8, 145, 178, 0.12)",
        "heroEyebrow": "Use case",
        "lastmod": "2026-07-13"
    },
    {
        "path": "/use-cases/house-hunting",
        "title": "Luckynote for House Hunting | Organize Listing Screenshots, Notes, and Viewing Details",
        "kind": "use_case",
        "icon": "FiHome",
        "iconColor": "#be123c",
        "iconBackground": "rgba(190, 18, 60, 0.12)",
        "heroEyebrow": "Use case",
        "lastmod": "2026-07-13"
    },
    {
        "path": "/use-cases/watchlist",
        "title": "Watchlist App for Movies and Books You Want to Remember | Luckynote",
        "kind": "use_case",
        "icon": "FiFilm",
        "iconColor": "#7c3aed",
        "iconBackground": "rgba(124, 58, 237, 0.12)",
        "heroEyebrow": "Use case",
        "lastmod": "2026-07-13"
    },
    {
        "path": "/use-cases/gift-ideas",
        "title": "Gift Ideas Tracker for Every Person and Occasion | Luckynote",
        "kind": "use_case",
        "icon": "FiGift",
        "iconColor": "#db2777",
        "iconBackground": "rgba(219, 39, 119, 0.12)",
        "heroEyebrow": "Use case",
        "lastmod": "2026-07-13"
    },
    {
        "path": "/use-cases/job-search",
        "title": "Organize Your Job Search in One Searchable Inbox | Luckynote",
        "kind": "use_case",
        "icon": "FiBriefcase",
        "iconColor": "#0369a1",
        "iconBackground": "rgba(3, 105, 161, 0.12)",
        "heroEyebrow": "Use case",
        "lastmod": "2026-07-13"
    },
    {
        "path": "/use-cases/home-projects",
        "title": "Home Renovation Organizer for Paint, Measurements, and Quotes | Luckynote",
        "kind": "use_case",
        "icon": "FiTool",
        "iconColor": "#b45309",
        "iconBackground": "rgba(180, 83, 9, 0.12)",
        "heroEyebrow": "Use case",
        "lastmod": "2026-07-13"
    },
    {
        "path": "/use-cases/event-planning",
        "title": "Personal Event Planning Organizer for Vendors, Quotes, and Deadlines | Luckynote",
        "kind": "use_case",
        "icon": "FiCalendar",
        "iconColor": "#0f766e",
        "iconBackground": "rgba(15, 118, 110, 0.12)",
        "heroEyebrow": "Use case",
        "lastmod": "2026-07-13"
    },
    {
        "path": "/use-cases/journaling",
        "title": "A Journaling App That Mixes Text, Voice, and Photos | Luckynote",
        "kind": "use_case",
        "icon": "FiEdit3",
        "iconColor": "#d97706",
        "iconBackground": "rgba(217, 119, 6, 0.12)",
        "heroEyebrow": "Use case",
        "lastmod": "2026-07-12"
    },
    {
        "path": "/use-cases/brain-dump",
        "title": "A Brain Dump App to Empty Your Head | Luckynote",
        "kind": "use_case",
        "icon": "FiCloud",
        "iconColor": "#7c3aed",
        "iconBackground": "rgba(124, 58, 237, 0.12)",
        "heroEyebrow": "Use case",
        "lastmod": "2026-07-13"
    },
    {
        "path": "/use-cases/reading-and-learning",
        "title": "Build a Personal Reading Library You Can Search | Luckynote",
        "kind": "use_case",
        "icon": "FiSearch",
        "iconColor": "#0891b2",
        "iconBackground": "rgba(8, 145, 178, 0.12)",
        "heroEyebrow": "Use case",
        "lastmod": "2026-07-12"
    },
    {
        "path": "/use-cases/competitive-research",
        "title": "Track Competitors with Screenshots and Searchable OCR | Luckynote",
        "kind": "use_case",
        "icon": "FiTrendingUp",
        "iconColor": "#be123c",
        "iconBackground": "rgba(190, 18, 60, 0.12)",
        "heroEyebrow": "Use case",
        "lastmod": "2026-07-12"
    },
    {
        "path": "/compare/glasp-alternative",
        "title": "Glasp Alternative | Luckynote",
        "kind": "comparison",
        "heroEyebrow": "Comparison",
        "lastmod": "2026-09-24"
    },
    {
        "path": "/compare/mymind-alternative",
        "title": "mymind Alternative | Luckynote",
        "kind": "comparison",
        "heroEyebrow": "Comparison",
        "lastmod": "2026-08-30"
    },
    {
        "path": "/compare/mymind-alternatives",
        "title": "mymind Alternatives | Luckynote",
        "kind": "comparison",
        "heroEyebrow": "Comparison",
        "lastmod": "2026-08-30"
    },
    {
        "path": "/compare/fabric-alternative",
        "title": "Fabric (fabric.so) Alternative | Luckynote",
        "kind": "comparison",
        "heroEyebrow": "Comparison",
        "lastmod": "2026-08-30"
    },
    {
        "path": "/compare/evernote-alternative",
        "title": "Evernote Alternative | Luckynote",
        "kind": "comparison",
        "heroEyebrow": "Comparison",
        "lastmod": "2026-07-07"
    },
    {
        "path": "/compare/evernote-alternatives",
        "title": "Evernote Alternatives | Luckynote",
        "kind": "comparison",
        "heroEyebrow": "Comparison",
        "lastmod": "2026-08-30"
    },
    {
        "path": "/compare/notion-alternative",
        "title": "Notion Alternative | Luckynote",
        "kind": "comparison",
        "heroEyebrow": "Comparison",
        "lastmod": "2026-08-31"
    },
    {
        "path": "/compare/notion-alternatives",
        "title": "Notion Alternatives | Luckynote",
        "kind": "comparison",
        "heroEyebrow": "Comparison",
        "lastmod": "2026-11-01"
    },
    {
        "path": "/compare/obsidian-alternative",
        "title": "Obsidian Alternative | Luckynote",
        "kind": "comparison",
        "heroEyebrow": "Comparison",
        "lastmod": "2026-08-30"
    },
    {
        "path": "/compare/obsidian-alternatives",
        "title": "Obsidian Alternatives | Luckynote",
        "kind": "comparison",
        "heroEyebrow": "Comparison",
        "lastmod": "2026-08-30"
    },
    {
        "path": "/compare/capacities-alternative",
        "title": "Capacities Alternative | Luckynote",
        "kind": "comparison",
        "heroEyebrow": "Comparison",
        "lastmod": "2026-08-30"
    },
    {
        "path": "/compare/capacities-alternatives",
        "title": "Capacities Alternatives | Luckynote",
        "kind": "comparison",
        "heroEyebrow": "Comparison",
        "lastmod": "2026-08-30"
    },
    {
        "path": "/compare/raindrop-alternative",
        "title": "Raindrop Alternative | Luckynote",
        "kind": "comparison",
        "heroEyebrow": "Comparison",
        "lastmod": "2026-07-12"
    },
    {
        "path": "/compare/otter-alternative",
        "title": "Otter Alternative | Luckynote",
        "kind": "comparison",
        "heroEyebrow": "Comparison",
        "lastmod": "2026-07-12"
    },
    {
        "path": "/compare/google-drive-alternative",
        "title": "Google Drive Alternative | Luckynote",
        "kind": "comparison",
        "heroEyebrow": "Comparison",
        "lastmod": "2026-07-12"
    },
    {
        "path": "/compare/dropbox-alternative",
        "title": "Dropbox Alternative | Luckynote",
        "kind": "comparison",
        "heroEyebrow": "Comparison",
        "lastmod": "2026-07-12"
    },
    {
        "path": "/compare/pinterest-alternative",
        "title": "Pinterest Alternative | Luckynote",
        "kind": "comparison",
        "heroEyebrow": "Comparison",
        "lastmod": "2026-07-12"
    },
    {
        "path": "/compare/voicenotes-alternative",
        "title": "VoiceNotes Alternative | Luckynote",
        "kind": "comparison",
        "heroEyebrow": "Comparison",
        "lastmod": "2026-07-12"
    },
    {
        "path": "/compare/pocket-vs-raindrop",
        "title": "Pocket vs Raindrop: Which Read-Later App Should You Use? | Luckynote",
        "kind": "comparison",
        "heroEyebrow": "Head to head",
        "lastmod": "2026-08-31"
    },
    {
        "path": "/compare/notion-vs-evernote",
        "title": "Notion vs Evernote: Which Should You Use? | Luckynote",
        "kind": "comparison",
        "heroEyebrow": "Head to head",
        "lastmod": "2026-08-31"
    },
    {
        "path": "/compare/mymind-vs-fabric",
        "title": "mymind vs Fabric: Which AI Save Tool Fits You? | Luckynote",
        "kind": "comparison",
        "heroEyebrow": "Head to head",
        "lastmod": "2026-08-31"
    },
    {
        "path": "/use-cases/why-people-text-themselves",
        "title": "Why Do People Text Themselves? | Luckynote",
        "kind": "use_case",
        "icon": "FiMessageSquare",
        "iconColor": "#2b88d9",
        "iconBackground": "rgba(43, 136, 217, 0.12)",
        "lastmod": "2026-09-19"
    },
    {
        "path": "/use-cases/best-apps-to-message-yourself",
        "title": "Best Apps to Message Yourself and Save Notes | Luckynote",
        "kind": "use_case",
        "icon": "FiMessageCircle",
        "iconColor": "#9333ea",
        "iconBackground": "rgba(147, 51, 234, 0.12)",
        "lastmod": "2026-09-19"
    },
    {
        "path": "/use-cases/send-notes-from-phone-to-computer",
        "title": "How to Send Notes From Your Phone to Your Computer | Luckynote",
        "kind": "use_case",
        "icon": "FiSend",
        "iconColor": "#0f766e",
        "iconBackground": "rgba(15, 118, 110, 0.12)",
        "lastmod": "2026-09-19"
    },
    {
        "path": "/use-cases/organize-saved-links-without-folders",
        "title": "How to Organize Saved Links Without Folders | Luckynote",
        "kind": "use_case",
        "icon": "FiLink2",
        "iconColor": "#16a34a",
        "iconBackground": "rgba(22, 163, 74, 0.12)",
        "lastmod": "2026-09-19"
    },
    {
        "path": "/use-cases/save-instagram-and-tiktok-ideas",
        "title": "How to Save Instagram and TikTok Ideas So You Can Find Them Later | Luckynote",
        "kind": "use_case",
        "icon": "FiBookmark",
        "iconColor": "#db2777",
        "iconBackground": "rgba(219, 39, 119, 0.12)",
        "lastmod": "2026-09-19"
    },
    {
        "path": "/use-cases/search-text-in-screenshots",
        "title": "Search Text in Screenshots and Images | Luckynote",
        "kind": "use_case",
        "icon": "FiImage",
        "iconColor": "#7c3aed",
        "iconBackground": "rgba(124, 58, 237, 0.12)",
        "lastmod": "2026-09-19"
    },
    {
        "path": "/use-cases/voice-note-transcription",
        "title": "Voice Note Transcription for Personal Notes | Luckynote",
        "kind": "use_case",
        "icon": "FiMic",
        "iconColor": "#f97316",
        "iconBackground": "rgba(249, 115, 22, 0.12)",
        "lastmod": "2026-10-07"
    },
    {
        "path": "/use-cases/save-web-pages-with-context",
        "title": "Save Web Pages and Links With Context | Luckynote",
        "kind": "use_case",
        "icon": "FiGlobe",
        "iconColor": "#0369a1",
        "iconBackground": "rgba(3, 105, 161, 0.12)",
        "lastmod": "2026-09-19"
    },
    {
        "path": "/use-cases/turn-saved-notes-into-reminders",
        "title": "Turn Saved Notes Into Reminders | Luckynote",
        "kind": "use_case",
        "icon": "FiBell",
        "iconColor": "#b45309",
        "iconBackground": "rgba(180, 83, 9, 0.12)",
        "lastmod": "2026-09-19"
    },
    {
        "path": "/use-cases/cross-device-note-capture",
        "title": "Cross-Device Note Capture for Phone, Web, and Desktop | Luckynote",
        "kind": "use_case",
        "icon": "FiSmartphone",
        "iconColor": "#2563eb",
        "iconBackground": "rgba(37, 99, 235, 0.12)",
        "lastmod": "2026-09-19"
    },
    {
        "path": "/message-yourself/whatsapp",
        "title": "WhatsApp Message Yourself, Made Searchable | Luckynote",
        "kind": "message_yourself",
        "icon": "FiMessageCircle",
        "iconColor": "#16a34a",
        "iconBackground": "rgba(22, 163, 74, 0.12)",
        "heroEyebrow": "Message yourself",
        "lastmod": "2026-10-07"
    },
    {
        "path": "/message-yourself/telegram",
        "title": "Telegram Saved Messages Alternative | Luckynote",
        "kind": "message_yourself",
        "icon": "FiSend",
        "iconColor": "#0284c7",
        "iconBackground": "rgba(2, 132, 199, 0.12)",
        "heroEyebrow": "Message yourself",
        "lastmod": "2026-10-07"
    },
    {
        "path": "/message-yourself/signal",
        "title": "Signal Note to Self, Made Easier to Retrieve | Luckynote",
        "kind": "message_yourself",
        "icon": "FiShield",
        "iconColor": "#2563eb",
        "iconBackground": "rgba(37, 99, 235, 0.12)",
        "heroEyebrow": "Message yourself",
        "lastmod": "2026-07-13"
    },
    {
        "path": "/message-yourself/slack",
        "title": "Slack Message Yourself for Notes | Luckynote",
        "kind": "message_yourself",
        "icon": "FiBriefcase",
        "iconColor": "#7c3aed",
        "iconBackground": "rgba(124, 58, 237, 0.12)",
        "heroEyebrow": "Message yourself",
        "lastmod": "2026-07-13"
    },
    {
        "path": "/message-yourself/discord",
        "title": "Discord Private Server for Notes | Luckynote",
        "kind": "message_yourself",
        "icon": "FiHash",
        "iconColor": "#4f46e5",
        "iconBackground": "rgba(79, 70, 229, 0.12)",
        "heroEyebrow": "Message yourself",
        "lastmod": "2026-07-13"
    },
    {
        "path": "/guides/save-links-for-school",
        "title": "Best Way to Save Links for School | Luckynote",
        "kind": "guide",
        "icon": "FiBookOpen",
        "iconColor": "#0f766e",
        "iconBackground": "rgba(15, 118, 110, 0.12)",
        "heroEyebrow": "Guide",
        "lastmod": "2026-09-08"
    },
    {
        "path": "/guides/save-from-instagram",
        "title": "How to Save Instagram Posts to Luckynote | Luckynote",
        "kind": "guide",
        "icon": "SiInstagram",
        "iconColor": "#E4405F",
        "iconBackground": "rgba(228, 64, 95, 0.12)",
        "heroEyebrow": "Guide",
        "lastmod": "2026-07-17"
    },
    {
        "path": "/guides/save-from-tiktok",
        "title": "How to Save TikToks to Luckynote | Luckynote",
        "kind": "guide",
        "icon": "SiTiktok",
        "iconColor": "#010101",
        "iconBackground": "rgba(1, 1, 1, 0.08)",
        "heroEyebrow": "Guide",
        "lastmod": "2026-07-17"
    },
    {
        "path": "/guides/save-from-x",
        "title": "How to Save Posts from X to Luckynote | Luckynote",
        "kind": "guide",
        "icon": "SiX",
        "iconColor": "#000000",
        "iconBackground": "rgba(0, 0, 0, 0.08)",
        "heroEyebrow": "Guide",
        "lastmod": "2026-09-21"
    },
    {
        "path": "/guides/save-x-threads",
        "title": "How to Save X (Twitter) Threads Automatically | Luckynote",
        "kind": "guide",
        "icon": "FiLayers",
        "iconColor": "#111827",
        "iconBackground": "rgba(17, 24, 39, 0.08)",
        "heroEyebrow": "Guide",
        "lastmod": "2026-09-21"
    },
    {
        "path": "/guides/save-from-whatsapp",
        "title": "How to Save WhatsApp Messages to Luckynote | Luckynote",
        "kind": "guide",
        "icon": "SiWhatsapp",
        "iconColor": "#25D366",
        "iconBackground": "rgba(37, 211, 102, 0.12)",
        "heroEyebrow": "Guide",
        "lastmod": "2026-07-17"
    },
    {
        "path": "/guides/save-from-web",
        "title": "Best Way to Save Links Online | Luckynote",
        "kind": "guide",
        "icon": "FiGlobe",
        "iconColor": "#2563eb",
        "iconBackground": "rgba(37, 99, 235, 0.12)",
        "heroEyebrow": "Guide",
        "lastmod": "2026-09-08"
    },
    {
        "path": "/guides/save-screenshots",
        "title": "How to Save Screenshots to Luckynote | Luckynote",
        "kind": "guide",
        "icon": "FiImage",
        "iconColor": "#7c3aed",
        "iconBackground": "rgba(124, 58, 237, 0.12)",
        "heroEyebrow": "Guide",
        "lastmod": "2026-07-17"
    },
    {
        "path": "/guides/save-pdfs-and-files",
        "title": "How to Save PDFs and Files to Luckynote | Luckynote",
        "kind": "guide",
        "icon": "FiFileText",
        "iconColor": "#b45309",
        "iconBackground": "rgba(180, 83, 9, 0.12)",
        "heroEyebrow": "Guide",
        "lastmod": "2026-07-17"
    },
    {
        "path": "/use-cases/whatsapp-transcriber",
        "title": "Transcriber for WhatsApp Voice Messages | Luckynote",
        "kind": "use_case",
        "icon": "FiMic",
        "iconColor": "#15803d",
        "iconBackground": "rgba(21, 128, 61, 0.12)",
        "heroEyebrow": "WhatsApp voice transcription",
        "lastmod": "2026-10-07"
    },
    {
        "path": "/use-cases/telegram-transcriber",
        "title": "Transcriber for Telegram Voice Messages | Luckynote",
        "kind": "use_case",
        "icon": "FiMic",
        "iconColor": "#0284c7",
        "iconBackground": "rgba(2, 132, 199, 0.12)",
        "heroEyebrow": "Telegram voice transcription",
        "lastmod": "2026-10-07"
    },
    {
        "path": "/guides/connect-whatsapp",
        "title": "How to Connect WhatsApp to Luckynote",
        "kind": "guide",
        "icon": "FiMessageSquare",
        "iconColor": "#0284c7",
        "iconBackground": "rgba(2, 132, 199, 0.12)",
        "heroEyebrow": "WhatsApp connection guide",
        "lastmod": "2026-10-07"
    },
    {
        "path": "/guides/connect-telegram",
        "title": "How to Connect Telegram to Luckynote",
        "kind": "guide",
        "icon": "FiMessageSquare",
        "iconColor": "#0284c7",
        "iconBackground": "rgba(2, 132, 199, 0.12)",
        "heroEyebrow": "Telegram connection guide",
        "lastmod": "2026-10-07"
    }
];

module.exports = { MARKETING_PAGE_META };
